import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/'
    }
  ]
})

const extend = () => { // closure to avoid polluting the global namespace
  // add custom methods to catch some errors
  const push = router.push
  router.push = function (...args) {
    return push.apply(router, args).catch(e => {
      if (e.name !== 'NavigationDuplicated') {
        throw e
      }
    })
  }
  const replace = router.replace
  router.replace = function (...args) {
    return replace.apply(router, args).catch(e => {
      if (e.name !== 'NavigationDuplicated') {
        throw e
      }
    })
  }
}

extend()

export default router
